import type { DefaultQueryError } from '@ahm/api-wrappers-core';
import { type UseQueryOptions, useQuery } from '@tanstack/react-query';
import { apiRoutes } from '@/api/api-routes';
import {
  getPackageSizeDefinitionsFn,
  type PackageSizeDefinitionsResponse,
} from '@/api/master-data/get-package-size-definition-fn';

export const useGetPackageSizeDefinitions = (
  deliveryType: string,
  opts?: Omit<
    UseQueryOptions<PackageSizeDefinitionsResponse[], DefaultQueryError>,
    'queryKey'
  >
) =>
  useQuery<PackageSizeDefinitionsResponse[], DefaultQueryError>({
    queryKey: [apiRoutes.packageSizeDefinitions, deliveryType],
    queryFn: () => getPackageSizeDefinitionsFn(deliveryType),
    ...opts,
  });
